import Skeleton from "react-loading-skeleton";

type Props = {
  count?: number;
};

export default function ChipsSkeleton({ count = 2 }: Props) {
  return (
    <div className="chips-skeleton" data-testid="chips-skeleton">
      {Array.from({ length: count }, (_, i) => (
        <Skeleton key={`chips-skeleton-${i}`} width={80} />
      ))}
    </div>
  );
}
